<template>
    <div class="flex flex-col items-center justify-center min-h-screen bg-black text-white">
      <h1 class="text-9xl font-semibold mb-8">404</h1>
      <p class="text-2xl mb-6">La page que vous recherchez est introuvable.</p>
      <router-link to="/" class="text-lg text-gray-400 hover:text-white transition">Retour à l'accueil</router-link>
    </div>
  </template>
  
  <script>
  export default {
    
    
  }
  </script>
  
  <style scoped>
  </style>